import generatePreview from './generate-preview';

export default [
  // Design 402
  // 'aff5ea63-34c8-40f0-8c65-a510460ba076', // 402 Large
  // '281d02c2-e7e5-4252-9e7b-2068a366fc01', // 402 Medium
  // 'cd9ca5e5-ed19-4729-812c-8182ab8fc5c7', // 402 Small

  // lisboa
  '23d97e24-99c2-4520-b1c8-09e182fdf9d0', // 1-001
  '29ad7b4d-25cd-44bb-9e06-d3fcc3eed182', // 2-001
  '03cecbb5-aafe-4c7e-ba6a-f7c331a24eea', // 2-002
  '332eb4b9-c33c-4aaa-967d-58bae5309545', // 3-001
  'd0acfa61-0063-4424-8df2-da4f98254fb8', // 4-001
  '3fbad118-6526-40db-864a-38807f4a7390', // 4-002
  '244c939e-eed5-428c-846f-9e4737ce53c3', // 5-001
  '48cc25cb-55f7-47f3-9fef-ddc5a450d85d', // 5-002
  'c7004e30-d53a-42dc-b64f-7676f788b818', // All-001
  '93beb7dd-edeb-4447-a264-ade07b1b2746', // All-002

  // Porto
  '97210965-f0e7-4142-bc58-c0eef97f07b8', // 1-001
  'fc41f36d-beb7-4920-a650-c2b13beb6bd2', // 1-002
  '515c1b94-da9d-466b-b354-571968374992', // 1-003

  '2ee4d11e-c94e-49dd-93b3-2f2fb6b3ebca', // 2-001
  'd3fb820a-cc5d-40ad-9efd-78c524c9b7b3', // 2-002
  'b2eb9482-17b3-4dae-80a1-85a58de9012a', // 2-003

  '81bb8afa-9574-45aa-b9be-2f42ccfa3ee8', // 3-001
  '274bee68-74bd-4776-804e-566b99927346', // 3-002
  '1d12c8b3-1016-4340-b439-70b640f1e367', // 3-003
  '2f096dee-b4c7-4e1e-94fa-a43531ce71e5', // 3-004
  '12c38751-6815-43ff-8421-75b9c5eed2eb', // 3-005
].map(generatePreview);



// WEBPACK FOOTER //
// ./src/client/lib/spinneybeck/patterns.js